import { render, staticRenderFns } from "./visitReservation.vue?vue&type=template&id=56bc37f8&scoped=true"
import script from "./visitReservation.vue?vue&type=script&setup=true&lang=js"
export * from "./visitReservation.vue?vue&type=script&setup=true&lang=js"
import style0 from "./visitReservation.vue?vue&type=style&index=0&id=56bc37f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bc37f8",
  null
  
)

export default component.exports